<template>
  <ToolboxMenu>
    <MenuItem>
      <LexmeaColorGrid
        :modelValue="modelValue"
        :wantedColors="['darkest', 'default']"
        @update:modelValue="handleBookmarkColorBoxClick"
      />
    </MenuItem>
    <MenuItem v-if="modelValue">
      <button
        class="group mt-2 flex w-full items-center gap-1 rounded-md p-2 text-gray-800 transition hover:bg-lexmea-pop-darker/10"
        @click="$emit('deleteBookmarks')"
      >
        <i-heroicons-no-symbol />
        {{ $t("legal_text.textEditor.buttons.remove_bookmark") }}
      </button>
    </MenuItem>
  </ToolboxMenu>
</template>

<script lang="ts" setup>
import type { ColorPicker } from "~/types/ColorPicker";

function handleBookmarkColorBoxClick(selectedColor: ColorPicker) {
  if (JSON.stringify(selectedColor) === JSON.stringify(props.modelValue)) {
    emits("deleteBookmarks");
  } else {
    emits("update:modelValue", selectedColor);
  }
}

const emits = defineEmits<{
  deleteBookmarks: [];
  "update:modelValue": [color: ColorPicker];
}>();

const props = defineProps<{
  modelValue: ColorPicker;
}>();
</script>
